import type { UrlSearchParams } from "@/features/discovery";

export function canonicalBrowseDogsSearch(search: UrlSearchParams) {
    return {
        to: "/find" as const,
        search,
        replace: true as const,
    };
}
